import Vue from 'vue'
import VueGoodTablePlugin from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import _ from 'lodash'
import { confirmFound } from '../animal-status-update'

Vue.use(VueGoodTablePlugin)

const tableEl = document.getElementById('v-my-lostpet-table')

export default Vue.component('my-lostpet-table', {
  data() {
    return {
      loading: false,
      errorMessage: '',
      /**
       * Type of modal - can be:
       * microchipRegisterPrompt
       * reportStatus
       * socialMedia
       */
      modalType: '',
      showModal: false,
      socialMediaModal: {
        sharingText: '',
        previewLink: '',
        facebookSharingLink: '',
      },
      // Controls action success/failure messages visibility within modal
      showFailureMessage: false,
      token: tableEl.dataset && tableEl.dataset.token,
      companionAnimalId: null,
      listingId: null,
      companionAnimalName: '',
      isGuardian: true,
      isLost: false,
      columns: [
        {
          label: '',
          field: 'avatar',
          tdClass: 'vgt-table__avatar-field',
        },
        {
          label: 'Name',
          field: 'name',
          tdClass: 'vgt-table__bold-cell vgt-table__name-field c-my-lostpet-table__name',
        },
        {
          label: 'Title',
          field: 'title',
          tdClass: 'c-my-lostpet-table__title',
        },
        {
          label: 'Listing Expiry',
          field: 'expiryDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd H:mm:ss',
          dateOutputFormat: 'dd/MM/yy',
          thClass: 'vgt-left-align',
          tdClass: 'vgt-left-align',
        },
        {
          label: 'Actions',
          field: 'actions',
          thClass: 'vgt-center-align vgt-table__cell--hide-mob',
          tdClass: 'vgt-table__cell--hide-mob-header',
          type: 'boolean',
        },
      ],
      rows: [],
      foundMethod: '',
      comment: '',
      showComment: false,
    }
  },
  created: function() {
    let queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)

    let showMicrochipRegisterModal = urlParams.get('mc-prompt') === 'true' ? true : false
    if (showMicrochipRegisterModal) {
      this.modalType = 'microchipRegisterPrompt'
      this.showModal = true
    }
    this.companionAnimalName = urlParams.get('name')

    this.loadTable()
  },
  beforeUnmount: function() {
    this.closeMicrochipPromptModal()
  },
  methods: {
    rowActionHandler(action, row) {
      if (typeof this[action] !== 'function') {
        console.error('Lost pet listing action not found:', action)
      } else {
        this[action](row)
      }
    },
    loadTable() {
      if (this.loading) {
        return
      }
      const loadStart = new Date().getTime()
      this.errorMessage = ''
      this.rows = []
      this.loading = true
      this.axios({
        method: 'GET',
        url: '/my-companion-animals/lost-pet/show-table/',
        maxRedirects: 0,
      })
        .then(res => {
          this.clearLoading(loadStart)
          if (res?.data?.status !== 'success') {
            this.errorMessage = 'An unknown error occurred, please refresh or try again later'
            this.rows = []
          } else {
            this.errorMessage = ''
            this.rows = res?.data?.results || []
          }
        })
        .catch(err => {
          this.clearLoading(loadStart)
          this.showFailureMessage = true
          this.errorMessage =
            err?.response?.data?.errors?.[0]?.value || 'An unknown error occurred, please refresh or try again later'
          this.rows = []
        })
    },
    // Ensures the loading state is enabled for at least 500ms to show that it did something
    clearLoading(loadStart) {
      const waitBeforeClearing = 500 - (new Date().getTime() - loadStart)
      if (waitBeforeClearing > 0) {
        window.setTimeout(() => {
          this.loading = false
        }, waitBeforeClearing)
      } else {
        this.loading = false
      }
    },
    toggleLost(row) {
      this.isLost = row.isLost
      this.companionAnimalName = row.name
      this.companionAnimalId = row.companionAnimalId
      this.listingId = row.id
      this.showModal = true
      this.modalType = 'reportStatus'
    },
    submitFound() {
      const formData = {
        foundMethod: this.foundMethod,
        comment: this.comment,
      }
      confirmFound.apply(this, [this.companionAnimalId, this.token, formData, this.listingId])
    },
    showSocialMediaModal(row) {
      this.companionAnimalName = row.name
      this.socialMediaModal.sharingText = row.socialSharingText
      this.socialMediaModal.previewLink = row.previewLink
      this.socialMediaModal.facebookSharingLink = row.facebookSharingLink
      this.showModal = true
      this.modalType = 'socialMedia'
    },
    copyTemplateText(e) {
      let copyText = document.getElementById('template-text')

      // This will not work locally, needs to be tested on dev site
      navigator.clipboard.writeText(copyText.innerText).then(() => {
        document.getElementById('copy-text-button').innerText = 'Copied!'
      })
    },
    refresh() {
      this.rows = this.rows.filter(row => row.id !== this.listingId)
      this.listingId = null
    },
    onFoundReasonChange(e) {
      if (e?.target?.value?.toLowerCase() === 'other') {
        this.showComment = true
      } else {
        this.showComment = false
      }
    },
    onModalClose() {
      this.showModal = false

      if (this.modalType == 'microchipRegisterPrompt') {
        this.closeMicrochipPromptModal()
      } else {
        this.clearModal()
      }

      this.modalType = ''
    },
    closeMicrochipPromptModal() {
      this.showModal = false
      this.modalType = ''
      this.companionAnimalName = ''

      let params = new URLSearchParams(window.location.search)

      // Delete the search parameters to show microchip modal.
      params.delete('mc-prompt')
      params.delete('name')

      const url = new URL(window.location.href)
      url.search = params.toString()
      window.history.replaceState(null, null, url.href)
    },
    clearModal() {
      this.showModal = false
      this.modalType = ''
      this.resetRowData()
      this.errors = {}
      this.showFailureMessage = false
      this.errorMessage = ''
      this.showComment = false
    },
    resetRowData() {
      this.isLost = false
      this.companionAnimalName = ''
      this.companionAnimalId = null
      this.foundMethod = ''
      this.comment = ''
      this.socialMediaModal.sharingText = ''
      this.socialMediaModal.previewLink = ''
      this.socialMediaModal.facebookSharingLink = ''
    },
  },
})
